module.exports = __webpack_public_path__ + "6e773839ecbbc6c4a9f4abdd9901851f.png";